// extracted by mini-css-extract-plugin
export default {"container":"_23OIM","divider":"_3mLzr"};